import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FuelTextField } from '@frete.com/fuel-react';

function FieldProduct() {
  const { control } = useFormContext();

  return (
    <Controller
      name="product.name"
      control={control}
      render={({ field: { onChange } }) => (
        <FuelTextField
          label="Produto"
          placeholder="Digite o produto"
          onFuel-input={onChange}
        />
      )}
      defaultValue=""
    />
  );
}

export default FieldProduct;
